import {
	AIFC_ADF_UPDATE_KEY,
	CONFLUENCE_AIFC_PAGE_CREATE_KEY,
} from '@atlassian/conversation-assistant-action-helpers/utils/confluence-actions';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';
import {
	type GeneratedEditVisualBlockCounts,
	getGeneratedEditVisualBlockCounts,
} from '@atlassian/rovo-content-bridge-api-commands/commands/generated-edit-visual-block-counts';
import {
	type GeneratedVisualBlockCounts,
	getGeneratedVisualBlockCounts,
} from '@atlassian/rovo-content-bridge-api-commands/commands/generated-visual-block-counts';

/** Page-create results carry the two totals; page edits add the six added/replaced/removed counts. */
export type MessageVisualBlockCounts = GeneratedVisualBlockCounts & GeneratedEditVisualBlockCounts;

const VISUAL_BLOCK_COUNT_READERS: Record<string, (data: unknown) => MessageVisualBlockCounts> = {
	[CONFLUENCE_AIFC_PAGE_CREATE_KEY]: getGeneratedVisualBlockCounts,
	[AIFC_ADF_UPDATE_KEY]: getGeneratedEditVisualBlockCounts,
};

/**
 * Reads the generated image / MAUI app block counts for analytics on events that describe a whole
 * assistant message. The counts belong to one generated page or one page edit, so they are reported
 * only when the message has exactly one page-create or page-edit action; otherwise there is no
 * single result to attribute them to, and nothing is reported.
 */
export const getMessageVisualBlockCounts = (
	actions: readonly Pick<MessageAction, 'key' | 'data'>[] | undefined,
): MessageVisualBlockCounts => {
	const countedActions =
		actions?.filter((action) => action.key in VISUAL_BLOCK_COUNT_READERS) ?? [];
	if (countedActions.length !== 1) {
		return {};
	}
	const [action] = countedActions;
	return VISUAL_BLOCK_COUNT_READERS[action.key](action.data);
};
